import React from 'react';
import { DateTime } from 'luxon';
import { GridColTypeDef } from '@mui/x-data-grid';
import { Link } from '@mui/material';
import Currency from 'components/formaters/Currency';
import Date from 'components/formaters/Date';


export const typeCurrency = (currency: string = 'jpy' ): GridColTypeDef => ({
    type: 'number',
    width: 110,
    renderCell: ({ value }) => <Currency value={value} currency={currency} />,
});

export const typePhone: GridColTypeDef = {
    renderCell: ({ value }) => <Link component="a" href={`tel:${value}`}>{value}</Link>,
};

export const typeEmail: GridColTypeDef = {
    renderCell: ({ value }) => <Link component="a" href={`mailto:${value}`}>{value}</Link>,
};

export const typeDate: GridColTypeDef = ({
    type: 'date',
    valueGetter: params => params.value && DateTime.fromISO(params.value),
    valueFormatter: params => params.value?.toISODate(), // TODO find reason of error without this line
    renderCell: params => <Date date={params.value} />,
});
